const config = {
    apiUrl: 'https://quiz-api.sharkdev.eu/api/',
    imageBaseUrl: 'https://quiz-api.sharkdev.eu/categories/'
};

export default config;